import { homeEn } from "./dict/home";
import { overlaysEn } from "./dict/overlays";
import { projectsEn } from "./dict/projects";
import { commonEn } from "./dict/common";

/** Russian source string -> natural business English. */
export const dictionary: Record<string, string> = {
  ...commonEn,
  ...homeEn,
  ...overlaysEn,
  ...projectsEn,
};
